import { FC, useEffect, useMemo, useState } from 'react'
import { Button, Form, Input, Modal } from 'antd'
import style from './style.m.less'
const { TextArea } = Input

export type MissingTranslation = { text: string }

export interface ITranslationModal {
    visible: boolean
    items: MissingTranslation[]
    onClose: () => void
    onSubmit: (ru: string, en: string, index: number) => Promise<void> | void
}

export const TranslationModal: FC<ITranslationModal> = ({ visible, items, onClose, onSubmit }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null)
    const [inputs, setInputs] = useState<Record<number, string>>({})
    const [pendingIndex, setPendingIndex] = useState<number | null>(null)

    const hasItems = useMemo(() => items?.length > 0, [items])

    useEffect(() => {
        if (visible) {
            setOpenIndex(null)
            setInputs({})
            setPendingIndex(null)
        }
    }, [visible, items])

    useEffect(() => {
        if (visible && !hasItems) {
            onClose()
        }
    }, [visible, hasItems, onClose])

    const handleOpen = (idx: number) => setOpenIndex(idx)

    const handleChange = (idx: number, val: string) =>
        setInputs((prev) => ({ ...prev, [idx]: val }))

    const handleFinish = async (idx: number) => {
        const ru = items[idx]?.text ?? ''
        const en = inputs[idx] ?? ''
        if (!en.trim()) {
            return
        }
        try {
            setPendingIndex(idx)
            await onSubmit(ru, en, idx)
        } finally {
            setPendingIndex(null)
            setOpenIndex(null)
        }
    }

    return (
        <Modal
            title="Нет переводов для следующих строк:"
            visible={visible && hasItems}
            onCancel={onClose}
            footer={
                <div className={style?.buttonsWrap}>
                    <Button onClick={onClose} className={style?.primaryButtonCancel}>
                        Закрыть
                    </Button>
                </div>
            }
            width={500}
            style={{ height: 'max-content', borderRadius: 24, overflow: 'hidden', padding: 0 }}
            bodyStyle={{
                width: '500px',
                height: 'max-content',
                maxHeight: '800px',
                overflowY: 'auto',
                padding: 0,
            }}
            destroyOnClose
            centered
            closable={false}
        >
            <ul style={{ margin: '20px', listStyle: 'none' }}>
                {items.map(({ text }, idx) => (
                    <li key={idx} style={{ marginBottom: '16px' }}>
                        <div>{text}</div>
                        {openIndex === idx ? (
                            <Form
                                layout="vertical"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px',
                                    marginTop: '8px',
                                }}
                                onFinish={() => handleFinish(idx)}
                            >
                                <Form.Item
                                    name={`translation_${idx}`}
                                    initialValue={inputs[idx] || ''}
                                    rules={[{ required: true, message: 'Введите перевод' }]}
                                >
                                    <TextArea
                                        rows={3}
                                        placeholder="Введите перевод"
                                        onChange={(e) => handleChange(idx, e.target.value)}
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    className={style?.primaryButton}
                                    htmlType="submit"
                                    loading={pendingIndex === idx}
                                >
                                    Отправить
                                </Button>
                            </Form>
                        ) : (
                            <Button
                                className={style?.primaryButton}
                                style={{ marginTop: '8px' }}
                                onClick={() => handleOpen(idx)}
                            >
                                Перевести
                            </Button>
                        )}
                    </li>
                ))}
            </ul>
        </Modal>
    )
}
